// import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import axiosInstance from 'Services/APIService';
// import { fetchFeedbacks } from '../carporateServices/feedbackAndManagementListSlice';

// // Define the form data type
// export interface OutreachFormData {
//   id?: string;
//   date_of_outreach?: string;
//   client_name?: string;
//   support_worker_name?: string;
//   service_type?: string;
//   other_service_type?: string;
//   description?: string;
//   goals?: string;
//   was_successful?: string;
//   explanation?: string;
//   support_worker_name_details?: string;
//   signature?: string;
//   date_completed?: string;
//   client_email?: string;
//   group_id?: string;
//   service_name_id?: string;
//   notes?: string;
//   action_taken?: string;
// }

// // Define the OutreachForm type to match API response and initialData
// export interface OutreachForm {
//   id?: string;
//   date_of_outreach?: string;
//   client_name?: string;
//   support_worker_name?: string;
//   type_of_outreach?: string;
//   description?: string;
//   goals?: string;
//   successful?: string;
//   explanation?: string;
//   sw_name?: string;
//   sw_signature?: string;
//   date_completed?: string;
//   client_email?: string;
//   notes?: string;
//   action_taken?: string;
//   created_by?: string;
//   created_at?: string;
// }

// // Define the state type
// export interface OutreachFormState {
//   loading: boolean;
//   message: string | null;
//   error: string | null;
// }

// // Define the initial state
// const initialState: OutreachFormState = {
//   loading: false,
//   message: null,
//   error: null
// };

// // Async thunk for posting outreach form data
// export const submitOutreachForm = createAsyncThunk<
//   { message: string },
//   { formData: OutreachFormData; initialData?: OutreachForm },
//   { rejectValue: string }
// >(
//   'outreachForm/submitOutreachForm',
//   async ({ formData, initialData }, { rejectWithValue, dispatch }) => {
//     try {
//       // Retrieve data from localStorage
//       const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
//         projectId?: string;
//       };
//       const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
//         selectedServiceTitle?: string;
//       };
//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';

//       if (!project.projectId || !service.selectedServiceTitle || !client_email) {
//         return rejectWithValue('Missing project, service, or client information in localStorage');
//       }

//       // Merge initialData with formData, prioritizing formData for updates
//       const payload = {
//         group_id: project.projectId,
//         service_name_id: service.selectedServiceTitle,
//         client_email,
//         id: formData.id,
//         date_of_outreach: initialData?.date_of_outreach || formData.date_of_outreach || '',
//         client_name: initialData?.client_name || formData.client_name || '',
//         support_worker_name: initialData?.support_worker_name || formData.support_worker_name || '',
//         type_of_outreach:
//           (initialData?.type_of_outreach || formData.service_type) === 'Other'
//             ? initialData?.type_of_outreach || formData.other_service_type || ''
//             : initialData?.type_of_outreach || formData.service_type || '',
//         description: initialData?.description || formData.description || '',
//         goals: initialData?.goals || formData.goals || '',
//         successful: initialData?.successful || formData.was_successful || '',
//         explanation: initialData?.explanation || formData.explanation || '',
//         sw_name: initialData?.sw_name || formData.support_worker_name_details || '',
//         sw_signature: initialData?.sw_signature || formData.signature || '',
//         date_completed: initialData?.date_completed || formData.date_completed || '',
//         notes: formData.notes || initialData?.notes || '',
//         action_taken: formData.action_taken || initialData?.action_taken || ''
//       };

//       const response = await axiosInstance.post('/ndis/form/outreach-forms', payload, {
//         headers: { 'Content-Type': 'application/json' }
//       });
//       await dispatch(fetchFeedbacks({ client_email })).unwrap();

//       return response.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to submit outreach form');
//     }
//   }
// );

// const outreachFormSlice = createSlice({
//   name: 'outreachForm',
//   initialState,
//   reducers: {
//     clearOutreachFormState: (state) => {
//       state.loading = false;
//       state.message = null;
//       state.error = null;
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(submitOutreachForm.pending, (state) => {
//         state.loading = true;
//         state.message = null;
//         state.error = null;
//       })
//       .addCase(submitOutreachForm.fulfilled, (state, action) => {
//         state.loading = false;
//         state.message = action.payload.message || 'Outreach form submitted successfully';
//         state.error = null;
//       })
//       .addCase(submitOutreachForm.rejected, (state, action) => {
//         state.loading = false;
//         state.message = null;
//         state.error = action.payload as string;
//       });
//   }
// });

// export const { clearOutreachFormState } = outreachFormSlice.actions;
// export default outreachFormSlice.reducer;

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
import { fetchFeedbacks } from '../carporateServices/feedbackAndManagementListSlice';

// Define the form data type
export interface OutreachFormData {
  id?: string;
  date_of_outreach?: string;
  client_name?: string;
  support_worker_name?: string;
  service_type?: string;
  other_service_type?: string;
  description?: string;
  goals?: string;
  was_successful?: string;
  explanation?: string;
  support_worker_name_details?: string;
  signature?: string;
  date_completed?: string;
  client_email?: string;
  group_id?: string;
  service_name_id?: string;
  notes?: string;
  action_taken?: string;
  resolved?: string;
}

// Define the OutreachForm type to match API response and initialData
export interface OutreachForm {
  id?: string;
  date_of_outreach?: string;
  client_name?: string;
  support_worker_name?: string;
  type_of_outreach?: string;
  description?: string;
  goals?: string;
  successful?: string;
  explanation?: string;
  sw_name?: string;
  sw_signature?: string;
  date_completed?: string;
  client_email?: string;
  notes?: string;
  action_taken?: string;
  created_by?: string;
  created_at?: string;
  resolved?: string;
}

// Define the state type
export interface OutreachFormState {
  loading: boolean;
  message: string | null;
  error: string | null;
}

// Define the initial state
const initialState: OutreachFormState = {
  loading: false,
  message: null,
  error: null
};

// Async thunk for posting outreach form data
export const submitOutreachForm = createAsyncThunk<
  { message: string },
  { formData: OutreachFormData; initialData?: OutreachForm },
  { rejectValue: string }
>(
  'outreachForm/submitOutreachForm',
  async ({ formData, initialData }, { rejectWithValue, dispatch }) => {
    try {
      // Retrieve data from localStorage
      const project = JSON.parse(localStorage.getItem('selectedProject') || '{}') as {
        projectId?: string;
      };
      const service = JSON.parse(localStorage.getItem('servicesState') || '{}') as {
        selectedServiceTitle?: string;
      };
      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';

      if (!project.projectId || !service.selectedServiceTitle || !client_email) {
        return rejectWithValue('Missing project, service, or client information in localStorage');
      }

      // Merge initialData with formData, prioritizing formData for updates
      const payload = {
        group_id: project.projectId,
        service_name_id: service.selectedServiceTitle,
        client_email,
        id: formData.id,
        date_of_outreach: initialData?.date_of_outreach || formData.date_of_outreach || '',
        client_name: initialData?.client_name || formData.client_name || '',
        support_worker_name: initialData?.support_worker_name || formData.support_worker_name || '',
        type_of_outreach:
          (initialData?.type_of_outreach || formData.service_type) === 'Other'
            ? initialData?.type_of_outreach || formData.other_service_type || ''
            : initialData?.type_of_outreach || formData.service_type || '',
        description: initialData?.description || formData.description || '',
        goals: initialData?.goals || formData.goals || '',
        successful: initialData?.successful || formData.was_successful || '',
        explanation: initialData?.explanation || formData.explanation || '',
        sw_name: initialData?.sw_name || formData.support_worker_name_details || '',
        sw_signature: initialData?.sw_signature || formData.signature || '',
        date_completed: initialData?.date_completed || formData.date_completed || '',
        notes: formData.notes || initialData?.notes || '',
        action_taken: formData.action_taken || initialData?.action_taken || '',
        resolved: initialData?.resolved || formData.resolved || ''
      };

      const response = await axiosInstance.post('/ndis/form/outreach-forms', payload, {
        headers: { 'Content-Type': 'application/json' }
      });
      await dispatch(fetchFeedbacks({ client_email })).unwrap();

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to submit outreach form');
    }
  }
);

const outreachFormSlice = createSlice({
  name: 'outreachForm',
  initialState,
  reducers: {
    clearOutreachFormState: (state) => {
      state.loading = false;
      state.message = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitOutreachForm.pending, (state) => {
        state.loading = true;
        state.message = null;
        state.error = null;
      })
      .addCase(submitOutreachForm.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message || 'Outreach form submitted successfully';
        state.error = null;
      })
      .addCase(submitOutreachForm.rejected, (state, action) => {
        state.loading = false;
        state.message = null;
        state.error = action.payload as string;
      });
  }
});

export const { clearOutreachFormState } = outreachFormSlice.actions;
export default outreachFormSlice.reducer;